//
//
//
//
//
//

export default {
  props: {
    color: {
      type: String,
      default: ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/comm/block/index.vue